import styled from 'styled-components';

const HeaderInfo = styled.div`
	display: flex;
	flex-direction: column;
	text-align: right;
	margin-right: 15px;
	position: relative;
	margin-right: 35px;
	h1 {
		font-size: 15px;
		line-height: 18px;
		font-family: 'RubikMedium';
		margin-bottom: 4px;
		span {
			font-size: 15px;
			line-height: 18px;
			font-family: 'RubikRegular';
		}
	}
	.icon {
		color: #58728c;
		font-size: 22px;
	}
	.notification-info {
		width: 10px;
		height: 10px;
		position: absolute;
		top: -1px;
		right: 0;
		background: #e8523f;
		border: 2px solid #000000;
		border-radius: 50%;
	}
	p {
		font-size: 13px;
		line-height: 15px;
	}
	@media screen and (max-width: 767px) {
		display: none !important;
	}
`;

export default HeaderInfo;
